import React from 'react'

function BillingsTab() {
  return (
    <div>BillingsTab</div>
  )
}

export default BillingsTab